import { Avatar } from '@material-ui/core';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import React from 'react'
import './Header.css';
import SearchIcon from '@material-ui/icons/Search'
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import {useStateValue} from './StateProvider';
import {auth} from './firebase';
import {useHistory} from 'react-router-dom';
import Drawer from '@material-ui/core/Drawer';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Hidden from '@material-ui/core/Hidden';
import Sidebar from './Sidebar';

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  drawer: {
    [theme.breakpoints.up('sm')]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  drawerPaper: {
    position:'relative',
    height: 'auto',
    width: drawerWidth,
  },
}));


function Header() {
    const classes = useStyles();
    const theme = useTheme();
    const [mobileOpen, setMobileOpen] = React.useState(false);

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    const [{user},dispatch] = useStateValue();
    const history = useHistory();

    const logout = () => {
        auth.signOut()
        .then(() => {
            dispatch({
            user: null
            });
        });
        history.push('/');
        window.location.reload();
    }
    
    return (
        <>
        <div className='header'>
            <div className='header__left'>
                <Avatar className='header__avatar' 
                alt={user?.displayName} 
                src={user?.photoURL}
                aria-label="open drawer"
                edge="start"
                onClick={handleDrawerToggle}
                />
                <AccessTimeIcon />
            </div>
            <div className='header__search'>
                <SearchIcon />
                <input placeholder="Search" />
            </div>
            <div className='header__help'>
                <HelpOutlineIcon />
            </div>
            <div className='header__right'>
                <ExitToAppIcon onClick={logout} />
            </div>
        </div>
        <nav className={classes.drawer} aria-label="mailbox folders">
            <Hidden smUp implementation="css">
                <Drawer 
                    variant="temporary"
                    anchor={theme.direction === 'rtl' ? 'right' : 'left'}
                    open={mobileOpen}
                    onClose={handleDrawerToggle}
                    classes={{
                      paper: classes.drawerPaper,
                    }}
                    ModalProps={{
                      keepMounted: true, // Better open performance on mobile.
                    }}
                    >
                <Sidebar />
                </Drawer>
                </Hidden>
            </nav>
        </>
    )
}

export default Header; 